import axios from 'axios';
import { PaginationResult } from '../types/paginationResult';
import { Airfield } from '../models/Airfield';
import { AirfieldCoordinates } from '../models/AirfieldCoordinates';

export class AirfieldService {
	async getAllAirfields(searchFilter: string = '', page: number = 1, recordsPerPage: number = 20, region: string = '', province: string = ''): Promise<PaginationResult<Airfield>> {
		try {
			const response = await axios.post('getAllAirfields', {
				page: page,
				recordsPerPage: recordsPerPage,
				searchFilter: searchFilter,
				region: region,
				province: province,
			});

			return response.data;
		} catch (error) {
			throw new Error("Error: " + error);
		}
	}


	async getAllAirfieldsCoordinates(searchFilter: string = '', region: string = '', province: string = ''): Promise<AirfieldCoordinates[]> {
		try {
			const response = await axios.post('getAllAirfieldsWithCoordinates', {
				searchFilter: searchFilter,
				region: region == "noRegion" ? "" : region,
				province: province == "noProvince" ? "" : province,
			});

			return response.data;
		} catch (error) {
			throw new Error("Error: " + error);
		}
	}

	async getAirfieldById(id: string): Promise<Airfield> {
		try {
			const response = await axios.post('getAirfield', { id: id });

			return response.data;
		} catch (error) {
			throw new Error("Error: " + error);
		}
	}

	async getAirfieldPhoto(id: string): Promise<string[]> {
		try {
			var response = await axios.post('GetAirfieldPhoto', { id: id });
			return response.data;

		} catch (error) {
			throw new Error("Error: " + error);
		}
	}
	async getAirfieldFirstPhoto(id: string): Promise<string> {
		try {
			var response = await axios.post('GetAirfieldFirstPhoto', { id: id });
			return response.data;

		} catch (error) {
			throw new Error("Error: " + error);
		}
	}

	async getAllAirfieldsWithFirstPhoto(searchFilter: string = '', page: number = 1, recordsPerPage: number = 20, region: string = '', province: string = ''): Promise<PaginationResult<Airfield>> {
		try {
			const response = await axios.post('GetAllAirfieldsWithFirstPhoto', {
				page: page,
				recordsPerPage: recordsPerPage,
				searchFilter: searchFilter,
				region: region == "noRegion" ? "" : region,
				province: province == "noProvince" ? "" : province,
			});
			return response.data;

		} catch (error) {
			throw new Error("Error: " + error);
		}
	}


}